export default __webpack_public_path__ + "static/media/Configure.cbfb3d7c.svg";